import { TextVariableDto } from "app/ApiClient";
import { LoadingState } from "types";

export type OpenEndVariablesState = {
  loading: LoadingState;
  openEndVariables: TextVariableDto[];
};
export const initialOpenEndVariablesState: OpenEndVariablesState = {
  loading: LoadingState.idle,
  openEndVariables: [],
};
